import { Module } from 'vuex-smart-module';
import ReportsServiceActions from './actions';
import ReportsServiceGetters from './getters';
import ReportsServiceMutations from './mutations';
import ReportsServiceState from './state';

export default new Module({
  state: ReportsServiceState,
  mutations: ReportsServiceMutations,
  actions: ReportsServiceActions,
  getters: ReportsServiceGetters,
});
